import PropTypes from "prop-types"
import React from "react"
import { CircleSpinnerOverlay } from "react-spinner-overlay"

const Loader = (props)=>{    
    const { loading } = props
    return (
        <CircleSpinnerOverlay
            loading={ loading } 
            overlayColor="rgba(0,153,255,0.2)"
            color="#002466"
        />
    )
}

Loader.propTypes = {
    loading: PropTypes.bool.isRequired
}

export default Loader
